import { render, staticRenderFns } from "./quickUser.vue?vue&type=template&id=454d3c90&scoped=true&"
import script from "./quickUser.vue?vue&type=script&lang=js&"
export * from "./quickUser.vue?vue&type=script&lang=js&"
import style0 from "./quickUser.vue?vue&type=style&index=0&id=454d3c90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454d3c90",
  null
  
)

export default component.exports